<template>
  <div>
    <b-container v-if="isLoading" class="text-center d-flex justify-content-center">
      <b-form>
        <br><br><br>
        <h5>{{ translate("loading") }}</h5>
        <br>
        <b-spinner style="color: rgb(109,122,82) !important"
          variant="warning"
        ></b-spinner>
      </b-form>
    </b-container>
    <div v-else>
      <b-container fluid v-if="this.inSession">
        <b-row>
          <b-col style="padding:0" align="center">
            <div class="menu-top" style="text-align:center">
              <p><b><span style="color: rgb(195,147,130)">WYNE</span></b>CELLAR</p>
            </div>
            <div>
              <img class="menu-overlay"
                :src="require('@/assets/img/menu.png')"
                v-b-toggle.menu-sidebar
              >
            </div>
            <hr>
          </b-col>
        </b-row>
        <b-row>
          <b-col style="padding:0" align="center">
              <p class="w-pagetitle" style="margin-left:20px;margin-right:20px; text-align:right;">{{cellar.name}} > {{ translate("content") }}</p>
              <b-row class="justify-content-center">
                <p class="t-title" style="width:90%; text-align: center;">{{ translate("overview of all units in") }} {{cellar.name }}</p>
              </b-row>
              <b-row class="justify-content-center">
                <p class="t-subtitle" style="width:90%; text-align: center;">{{ translate("to select one, click - to add one, click on the plus sign") }}</p>
              </b-row>
              <b-row class="justify-content-center" style="margin:0">
                <b-col 
                    class="w-tile m-2 d-inline-flex justify-content-center w-cursor-click"
                    xs="12" sm="6" md="4" lg="2" xl="2"
                    v-on:click="onEdit()"
                    style ="display:block; margin:20px !important"
                >
                  <b-img
                    width=300px
                    height=200px
                    :src="require('@/assets/img/plus.png')"
                  >
                  </b-img>
                </b-col> 

                <b-col
                  v-for="(niche, index) in niches"
                  v-bind:item="niche"
                  v-bind:index="index"
                  v-bind:key="niche._id"
                  class="w-tile m-2 d-inline-flex justify-content-center w-cursor-click"
                  xs="12" sm="6" md="4" lg="2" xl="2"
                  style ="display:block; margin:20px !important"
                >  
                  <b-row  
                    style="width:100%"
                    v-on:click="onSelect(niche._id)"
                  >
                    <b-col class="justify-content-center" style="height:100%;width:auto;padding:0;position:sticky">
                      <div v-if="niche.image_files[0]" 
                        class="c-image-part" 
                        v-bind:style="{ 'background-image': 'url(' + niche.image_files[0].dataURL +')' }"
                      >
                      </div>
                      <div v-else
                        class="c-image-part"
                      />
                      <div class="c-text-part">
                        <p class="c-title" v-if="niche.code">{{niche.code}} - {{niche.name}}</p>
                        <p class="c-title" v-else>{{niche.name}}</p>
                        <p class="c-subtitle" v-if="niche.description">{{niche.description}}</p>
                        <p class="c-bottles">{{niche.number_of_bottles}}</p>
                      </div>
                      <b-button pill
                        class="edit-button"
                        v-on:click.stop="onEdit(niche._id)"
                        v-b-tooltip.hover title="edit unit"
                      >
                        <font-awesome-icon class="edit-symbol" icon="edit" />
                      </b-button>
                      <b-button pill
                        v-if="niche.entry_ids.length == 0"
                        class="delete-button"
                        v-on:click.stop="onDelete(niche._id)"
                        v-b-tooltip.hover title="delete unit"
                      >
                        <font-awesome-icon class="delete-symbol" icon="trash-alt" />
                      </b-button>
                    </b-col>
                  </b-row> 
                </b-col>
              </b-row>
              <br>
          </b-col>
        </b-row>
        <b-sidebar 
          id="menu-sidebar" 
          backdrop
          backdrop-variant="dark" 
          no-header
          shadow
        >
          <template #default="{ hide }">
            <div style="display: flex; align-items: center;">
              <div style="display: flex;align-items: center; width:25 px">
                <b-dropdown 
                  left 
                  split 
                  text="language" 
                  class="language-dropdown" 
                  toggle-class="toggle-language" 
                  split-class="split-language" 
                  style="display: flex;font-size: 12px;margin:15px 0 0 10px"
                >
                  <template #button-content>
                    <img
                      :src="currentLanguageFlag"
                      style="width:28px; height:19px; border-radius:2px;"
                    >
                  </template>

                  <b-dropdown-item @click="selectLanguage('en')">
                    <img :src="require('@/assets/img/flags/english.png')" style="width: 37px; height: 25px;">
                    English
                  </b-dropdown-item>
                  <b-dropdown-item @click="selectLanguage('fr')">
                    <img :src="require('@/assets/img/flags/francais.png')" style="width: 37px; height: 25px;">
                    Français (French)
                  </b-dropdown-item>
                  <b-dropdown-item @click="selectLanguage('de')">
                    <img :src="require('@/assets/img/flags/deutsch.png')" style="width: 37px; height: 25px;">
                    Deutsch (German)
                  </b-dropdown-item>
                  <b-dropdown-item @click="selectLanguage('es')">
                    <img :src="require('@/assets/img/flags/spanish.png')" style="width: 37px; height: 25px;">
                    Español (Spanish)
                  </b-dropdown-item>
                  <b-dropdown-item @click="selectLanguage('it')">
                    <img :src="require('@/assets/img/flags/italian.png')" style="width: 37px; height: 25px;">
                    Italiano (Italian)
                  </b-dropdown-item>
                  <b-dropdown-item @click="selectLanguage('nl')">
                      <img :src="require('@/assets/img/flags/dutch.png')" style="width: 37px; height: 25px;">
                      Nederlands (Dutch)
                    </b-dropdown-item>
                    <b-dropdown-item @click="selectLanguage('pt')">
                      <img :src="require('@/assets/img/flags/portuguese.png')" style="width: 37px; height: 25px;">
                      Português (Portuguese)
                    </b-dropdown-item>
                </b-dropdown>
              </div>
              <div style="display: flex; align-items: center;">
                <p style="margin:20px 0 0 40px;"><b><span style="color: rgb(195,147,130)">WYNE</span></b>CELLAR</p>
              </div>
              <div style="display: flex; align-items: center; width:25 px">
                <img class="menu-overlay"
                  :src="require('@/assets/img/close.png')" 
                  style="width: 25px; height: 25px; cursor: pointer;" 
                  @click="hide"
                >
              </div>
            </div>
            <hr>
            <Menu/> 
          </template>
        </b-sidebar>
      </b-container>
      <NoAccess v-else></NoAccess>
    </div>

    <b-modal id="deleteNiche" ref="deleteNiche" title="delete unit" @ok="deleteNiche"> 
      <b-row v-if="current_index >=0">
        <div style="width:300px;margin-left:auto;margin-right:auto">
        <b-col
          class="w-tile m-2 d-inline-flex justify-content-center"
          style ="display:block; margin:20px !important"
        >
            <div v-if="niches[current_index].image_files[0]" 
              class="c-image-part" 
              v-bind:style="{'background-image': 'url(' + niches[current_index].image_files[0].dataURL +')' }"
            >
            </div>
            <div v-else
              class="c-image-part"
            />           
            <div class="c-text-part">
              <p class="c-title" v-if="niches[current_index].code">{{niches[current_index].code}} - {{niches[current_index].name}}</p>
              <p class="c-title" v-else>{{niches[current_index].name}}</p>
              <p class="c-subtitle" v-if="niches[current_index].description">{{niches[current_index].description}}</p>
              <p class="c-bottles">{{niches[current_index].number_of_bottles}}</p>
            </div>
        </b-col>
        </div>
      </b-row>
      <p class="t-title text-center">ARE YOU SHURE YOU WANT TO DELETE THIS UNIT?</p>
      
      <template #modal-footer="{ ok, cancel }">
        <b-row style="width:100%">  
          <b-col class="text-left">
            <b-button class="w-button-pink" @click="cancel()">
              cancel
            </b-button>
          </b-col>
          <b-col class="text-right">
            <b-button class="w-button-green" @click="ok()">
              ok
            </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>
  </div>
</template>

<script>
  import {wordlist,translate_word} from '../assets/js/translate.js';

  import NoAccess from '@/components/NoAccess.vue';
  import Menu from '@/components/MenuMobile.vue';

  import Users from '../Users.js'
  import Cellars from '../Cellars.js'
  import Niches from '../Niches.js'

  export default {
    name: "Cellar",
    components: {
      NoAccess,
      Menu
    },
    computed : {
      inSession() {
        return this.$store.state.inSession
      },
      currentUser() {
        return this.$store.state.user
      },
      currentUserID() {
        return this.$store.state.user_id
      },
      currentLanguage() {
        return this.$store.state.language
      },
      currentLanguageFlag() {
        const flags = {
          en: require('@/assets/img/flags/english.png'),
          fr: require('@/assets/img/flags/francais.png'),
          de: require('@/assets/img/flags/deutsch.png'),
          es: require('@/assets/img/flags/spanish.png'),
          it: require('@/assets/img/flags/italian.png'),
          nl: require('@/assets/img/flags/dutch.png'),
          pt: require('@/assets/img/flags/portuguese.png')
        }
        return flags[this.currentLanguage] || flags.en
      },  
      currentPage() {
        return this.$store.state.current_page
      },
      previousPage() {
        return this.$store.state.previous_page
      },
      currentCellarID() {
        return this.$store.state.cellar_id
      },
      currentCellar() {
        return this.$store.state.cellar
      },
      currentCellarLoaded() {
        return this.$store.state.cellar_loaded
      },
      currentNiches() {
        return this.$store.state.niches
      },
      currentNichesLoaded() {
        return this.$store.state.niches_loaded
      }
    },
    data() {
      return {
        debug: false,
        isLoading: true,
        
        cellar: {},
        cellar_id:0,

        niches: [],

        current_index:-1,

        inEdit: false,
      }
    }, 

    async mounted() {
      let local_debug = false

      if (local_debug || this.debug) console.log( "")
      if (local_debug || this.debug) console.log( "Cellar.mounted: START")

      let time_0 = new Date().getTime()
      
      // Load the Cellar
      if (this.currentCellarLoaded) {
        if (local_debug || this.debug) console.log("Cellar.mounted: CURRENT CELLAR LOADED")
        this.cellar = this.currentCellar
        this.cellar_id = this.currentCellarID
        if (local_debug || this.debug) console.log("Cellar.mounted: cellar ", this.cellar, " with id ", this.cellar_id, " succesfully retrieved from store.")
      }
      else {
        if (local_debug || this.debug) console.log("Cellar.mounted: CURRENT CELLAR NOT LOADED - QUERYING THE DATABASE")
        this.cellar_id = this.$route.query.cellar_id
        await Cellars.getone(this.cellar_id)
        .then(response => {
          this.cellar = response
          delete this.cellar._id
          if (local_debug || this.debug) console.log("Cellar.mounted: cellar ", this.cellar, " with id ", this.cellar_id, " succesfully fetched from DB.")
        })
        .catch(error =>{
          if (local_debug || this.debug) console.log("Cellar.mounted: catch Cellar.getone with error: ", error)
        })

        this.$store.commit('setCellar',this.cellar)
        this.$store.commit('setCellarID',this.cellar_id)
        this.$store.commit('setCellarLoaded',true)

        if (local_debug || this.debug) console.log("Cellar.mounted: cellar ", this.cellar, " with id ", this.cellar_id, " succesfully stored in store.")
      }

      // Load the Niches
      if (local_debug || this.debug) console.log("Cellar.mounted: This cellar has ", this.cellar.niche_ids.length, " niches:");
      if (this.currentNichesLoaded ) {
        if (local_debug || this.debug) console.log("Cellar.mounted: CURRENT NICHES LOADED")
        this.niches = this.currentNiches
        if (local_debug || this.debug) console.log("Cellar.mounted: niches ", this.niches, " succesfully retrieved from store.")
      } else {
        if (local_debug || this.debug) console.log("Cellar.mounted: CURRENT NICHES NOT LOADED - QUERYING THE DATABASE")

        if (this.cellar.niche_ids && this.cellar.niche_ids.length > 0) {
          const validNicheIds = this.cellar.niche_ids.filter(
            id => id && id.length === 24
          )

          this.niches = await Niches.getmany(validNicheIds)

          this.niches = this.niches.filter(niche => niche && typeof niche === "object")

          this.niches.sort((a, b) => a.code.localeCompare(b.code))

          this.$store.commit('setNiches', this.niches)
          this.$store.commit('setNichesLoaded', true)
        }
      }

      this.isLoading = false
      if (local_debug || this.debug) console.log( "Cellar.mounted: START")
    },

    methods: {
      onSelect(niche_id){
        if ( ! this.inEdit ) {
          this.$store.commit('setPage','NicheShow')
          this.$router.push({path:'/NicheShow', query: {cellar_id:this.$route.query.cellar_id,niche_id:niche_id }});
        }
      },
      onEdit(niche_id){
        this.inEdit = true;
        this.$store.commit('setPage','NicheEdit')
        if (typeof niche_id === "undefined") {
          this.$router.push({path:'/NicheEdit', query: {cellar_id:this.$route.query.cellar_id}});
        } else {
          this.$router.push({path:'/NicheEdit', query: {cellar_id:this.$route.query.cellar_id,niche_id:niche_id }});
        }
      },
      async onDelete(niche_id){
        let local_debug = false
        if (local_debug || this.debug) console.log("")
        if (local_debug || this.debug) console.log("Cellar.onDelete: START niche_id = ", niche_id)
        this.current_index = -1
        for ( let i=0 ;i<this.niches.length ; i++ ) {
          if (this.niches[i]._id == niche_id) {
            this.current_index = i
          }
        }
        if (this.current_index == -1) {
          if (local_debug || this.debug) console.log("Cellar.onDelete: SEVERE ERROR - stopping here.")
          alert("Severe error")
          return
        }
        
        if (local_debug || this.debug) console.log("Cellar.onDelete: STOP this.current_index = ", this.current_index)
        await this.$bvModal.show('deleteNiche')
      },

      async deleteNiche(){
        let local_debug = false
        if (local_debug || this.debug) console.log("")
        if (local_debug || this.debug) console.log("Cellar.deleteNiche: START")
        let this_niche_id = this.niches[this.current_index]._id
        this.cellar_id = this.$route.query.cellar_id;

        await Niches.delete(this_niche_id)
        .then(response => {
          if (local_debug || this.debug) console.log("Cellar.deleteNiche: niche with id ", this_niche_id, " deleted with response : ", response)
        })
        .catch(error => {
          if (local_debug || this.debug) console.log('Cellar in deleteNiche() : catch await Niches.delete ERROR : ' + error);
        })

        // Update cellar in the database
        let split_index = this.cellar.niche_ids.indexOf(this_niche_id)
        if (local_debug || this.debug) console.log("Cellar.deleteNiche: split_index = ", split_index)
        this.cellar.niche_ids.splice(split_index,1)
        await Cellars.update(this.cellar_id,this.cellar)
        .then(response => {
          if (local_debug || this.debug) console.log("Cellar.deleteNiche: cellar with id ", this.cellar_id, " updated with response : ", response)
        })
        .catch(error => {
          if (local_debug || this.debug) console.log('Cellar in deleteNiche() : catch await Cellars.update ERROR : ' + error);
        })

        // Update cellar in the store
        this.$store.commit('setCellar',this.cellar)
        if (local_debug || this.debug) console.log("Cellar.deleteNiche: cellar ", this.cellar_id, " updated in store")

        this.niches.splice(this.current_index,1);
        this.niches.sort(function(a, b) {
            console.log(a.code,'/',b.code)
            if(a.code < b.code) { return -1; }
            if(a.code > b.code) { return 1; }
            return 0;
        });
        this.current_index = -1;

        if (local_debug || this.debug) console.log("Cellar.deleteNiche: STOP")
      },

      async selectLanguage(language) {
        let local_debug = false
        if (local_debug || this.debug) console.log("TastingShow.selectLanguage: START");
        this.$store.commit('setLanguage',language)

        let user = this.currentUser
        let user_id = this.currentUserID
        user.language = language
        await Users.update(user_id, user)
        .then(response => {
          if (local_debug || this.debug) console.log ("TastingShow.selectLanguage: user ",user.email," updated with response ", response)
        })
        .catch(error => {
          if (local_debug || this.debug) console.log('TastingShow.selectLanguage: catch await Users.update ERROR : ', error);
        })

        this.refreshChild++

        if (local_debug || this.debug) console.log("TastingShow.selectLanguage: STOP");
      },
      
      translate(string) {
        if (string == 'Wine') console.log("TMP: translate ", string," to ",this.currentLanguage, " ", translate_word(string, this.currentLanguage))
        return translate_word(string, this.currentLanguage);
      },
    }
  }      
</script>

<style>
@import url("../assets/styles/wynestyle.css");
</style>

<style scoped>
.c-image-part {
  background-image: url("../assets/img/niche-picture.jpg")
}
</style>
